<div class="checkbox" [ngClass]="{'selected': isSelected}"></div>
